"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _draftJs = require("draft-js");

require("draft-js-alignment-plugin/lib/plugin.css");

var _draftJsPluginsEditor = _interopRequireWildcard(require("draft-js-plugins-editor"));

var _BlockInlineToolbar = _interopRequireDefault(require("./custom/blockInlineToolbar/BlockInlineToolbar"));

var _draftJsEmojiPlugin = _interopRequireDefault(require("draft-js-emoji-plugin"));

var _draftJsInlineToolbarPlugin = _interopRequireDefault(require("draft-js-inline-toolbar-plugin"));

require("draft-js-inline-toolbar-plugin/lib/plugin.css");

var _draftJsImagePlugin = _interopRequireDefault(require("draft-js-image-plugin"));

require("draft-js-image-plugin/lib/plugin.css");

var _draftJsMentionPlugin = _interopRequireDefault(require("draft-js-mention-plugin"));

require("draft-js-mention-plugin/lib/plugin.css");

var _EntryComponent = _interopRequireDefault(require("./custom/mention/EntryComponent"));

var _ExportToHtml = _interopRequireDefault(require("./custom/exporter/ExportToHtml"));

exports.exportHtml = _ExportToHtml["default"];

var _draftJsResizeablePlugin = _interopRequireDefault(require("draft-js-resizeable-plugin"));

var _draftJsFocusPlugin = _interopRequireDefault(require("draft-js-focus-plugin"));

var _draftJsDragNDropPlugin = _interopRequireDefault(require("draft-js-drag-n-drop-plugin"));

var _inlineToolbar = require("./custom/inlineToolbar");

var _draftJsButtons = require("draft-js-buttons");

var _draftJsCustomStyles = _interopRequireDefault(require("draft-js-custom-styles"));

var _draftJsAnchorPlugin = _interopRequireDefault(require("draft-js-anchor-plugin"));

require("draft-js-anchor-plugin/lib/plugin.css");

var _SideToolbar = _interopRequireDefault(require("./custom/sideToolbar/SideToolbar"));

var _SettingsTools = _interopRequireDefault(require("./custom/sideToolbar/SettingsTools"));

var _CustomImageContainer = _interopRequireDefault(require("./custom/containers/CustomImageContainer"));

var _AddCustomAttribute = _interopRequireDefault(require("./custom/components/AddCustomAttribute"));

var _ButtonContainer = _interopRequireDefault(require("./custom/containers/ButtonContainer"));

var _FooterContainer = _interopRequireDefault(require("./custom/plugins/footerPlugin/FooterContainer"));

var _CreateCustomPlugin = _interopRequireDefault(require("./custom/plugins/CreateCustomPlugin"));

var _immutable = _interopRequireDefault(require("immutable"));

var _shoutoutThemesEnterprise = require("@shoutout-labs/shoutout-themes-enterprise");

var _FaICIconMap = require("./FaICIconMap");

var _TextContainer = _interopRequireDefault(require("./custom/containers/TextContainer"));

var _Preview = _interopRequireDefault(require("./custom/preview/Preview"));

exports.Preview = _Preview["default"];

var _SuggestionsFilter = _interopRequireDefault(require("./custom/mention/SuggestionsFilter"));

var _Modifiers = require("./custom/utils/Modifiers");

var _EditorContext = require("./EditorContext");

var _Constants = _interopRequireDefault(require("./Constants"));

require("./EmailEditor.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var emojiPlugin = (0, _draftJsEmojiPlugin["default"])({
  selectButtonContent: /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-dark d-flex flex-column"
  }, /*#__PURE__*/_react["default"].createElement(_shoutoutThemesEnterprise.IcIcon, {
    className: "mx-auto my-auto",
    icon: _FaICIconMap.faSmile,
    size: "1_3x"
  }), /*#__PURE__*/_react["default"].createElement("small", {
    className: "d-block mt-2"
  }, "Emoji"))
});
var focusPlugin = (0, _draftJsFocusPlugin["default"])();
var resizeablePlugin = (0, _draftJsResizeablePlugin["default"])();
var blockInlineToolbarPlugin = (0, _BlockInlineToolbar["default"])();
var BlockInlineToolbarTool = blockInlineToolbarPlugin.BlockInlineToolbarTool;
var blockDndPlugin = (0, _draftJsDragNDropPlugin["default"])();
var decorator = (0, _draftJsPluginsEditor.composeDecorators)(resizeablePlugin.decorator, blockInlineToolbarPlugin.decorator, focusPlugin.decorator, blockDndPlugin.decorator);
var linkPlugin = (0, _draftJsAnchorPlugin["default"])({
  placeholder: 'http://…'
});

var blockStyleFn = function blockStyleFn(contentBlock) {
  var type = contentBlock.getType();
  var blockAlignment = contentBlock.getData() && contentBlock.getData().get('text-align');

  if (blockAlignment) {
    return "paragraph " + blockAlignment;
  }

  if (type === "unstyled") {
    return "paragraph";
  }
};

var DraftEmailEditor = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEmailEditor, _React$Component);

  function DraftEmailEditor(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    _this.focus = function () {
      return _this.editor ? _this.editor.focus() : null;
    };

    _this.onChange = _this.context.onChangeEditorState;
    _this._handleReturn = _this._handleReturn.bind(_assertThisInitialized(_this));

    _this.handleKeyCommand = function (command) {
      return _this._handleKeyCommand(command);
    };

    _this.onTab = function (e) {
      return _this._onTab(e);
    };

    _this._onMentionSearchChange = _this._onMentionSearchChange.bind(_assertThisInitialized(_this));
    _this.editorRef = _react["default"].createRef();

    _this._init();

    _this.state = {
      mentions: []
    };
    return _this;
  }

  var _proto = DraftEmailEditor.prototype;

  _proto._init = function _init() {
    var _this2 = this;

    var ctx = this;
    this.imagePlugin = (0, _draftJsImagePlugin["default"])({
      decorator: decorator,
      imageComponent: function imageComponent(props) {
        return /*#__PURE__*/_react["default"].createElement(_CustomImageContainer["default"], _extends({}, props, {
          editorState: ctx.context.editorState,
          onChangeEditorState: ctx.onChange,
          theme: ctx.context.selectedTheme
        }));
      }
    });
    this.customAttributeSetting = (0, _AddCustomAttribute["default"])({
      customAttributes: this.props.customAttributes
    });

    var _createStyles = (0, _draftJsCustomStyles["default"])(['color', 'font-size', 'font-family'], 'CUSTOM_', this.context.selectedTheme),
        customStyleFn = _createStyles.customStyleFn;

    this.customStyleFn = customStyleFn;
    var inlineToolbarPlugin = (0, _draftJsInlineToolbarPlugin["default"])({
      structure: [_draftJsButtons.BoldButton, _draftJsButtons.ItalicButton, _draftJsButtons.UnderlineButton, _inlineToolbar.AlignmentButton, _inlineToolbar.ListButton, linkPlugin.LinkButton, function (props) {
        return /*#__PURE__*/_react["default"].createElement(_inlineToolbar.FontsButton, _extends({}, props, {
          selectedTheme: ctx.context.selectedTheme
        }));
      }, _inlineToolbar.FontsSizeButton, function (props) {
        return /*#__PURE__*/_react["default"].createElement(_inlineToolbar.FontsColorButton, _extends({}, props, {
          selectedTheme: ctx.context.selectedTheme
        }));
      }]
    });
    var InlineToolbar = inlineToolbarPlugin.InlineToolbar;
    this.InlineToolbar = InlineToolbar;
    var buttonPlugin = (0, _CreateCustomPlugin["default"])({
      decorator: decorator,
      component: _ButtonContainer["default"],
      type: _Constants["default"].ENTITY_TYPES.BUTTON
    });
    var footerPlugin = (0, _CreateCustomPlugin["default"])({
      decorator: decorator,
      component: function component(props) {
        return /*#__PURE__*/_react["default"].createElement(_FooterContainer["default"], _extends({}, props, {
          editorState: ctx.context.editorState,
          onChangeEditorState: _this2.onChange
        }));
      },
      type: "footer",
      editorTheme: ctx.context.selectedTheme
    });
    this.mentionPlugin = (0, _draftJsMentionPlugin["default"])();
    var MentionSuggestions = this.mentionPlugin.MentionSuggestions;
    this.MentionSuggestions = MentionSuggestions;
    this.plugins = [blockInlineToolbarPlugin, emojiPlugin, this.imagePlugin, resizeablePlugin, focusPlugin, inlineToolbarPlugin, linkPlugin, buttonPlugin, blockDndPlugin, this.mentionPlugin, footerPlugin];
    this.blocksWithoutStyleReset = [];
    this.blockRenderMap = _draftJs.DefaultDraftBlockRenderMap.merge(_immutable["default"].Map({
      'unstyled': {
        element: 'span',
        wrapper: /*#__PURE__*/_react["default"].createElement(_TextContainer["default"], {
          theme: this.context.selectedTheme
        })
      },
      'header-one': {
        element: 'span',
        wrapper: /*#__PURE__*/_react["default"].createElement(_TextContainer["default"], {
          theme: this.context.selectedTheme,
          type: "title"
        })
      },
      'header-two': {
        element: 'span',
        wrapper: /*#__PURE__*/_react["default"].createElement(_TextContainer["default"], {
          theme: this.context.selectedTheme,
          type: "sub-title"
        })
      }
    }));
  };

  _proto.componentDidMount = function componentDidMount() {
    if (!this.context.editorState) {
      this.onChange((0, _Modifiers.resetWithDefaultTemplate)(this.context.metadata));
    }
  };

  _proto._isFooterContains = function _isFooterContains(block) {
    if (block.getType() === "atomic") {
      //check footer entity
      var entity = _draftJs.Entity.get(block.getEntityAt(0));

      if (entity && entity.type === "footer") {
        return true;
      }
    }

    return false;
  };

  _proto._handleKeyCommand = function _handleKeyCommand(command) {
    var editorState = this.context.editorState;
    var handled = false;

    if (command === "backspace" || command === "delete") {
      var contentState = editorState.getCurrentContent();
      var selectionState = editorState.getSelection();
      var currentAnchorKey = selectionState.getAnchorKey();
      var currentBlock = contentState.getBlockForKey(currentAnchorKey);

      if (this._isFooterContains(currentBlock)) {
        //current selection is the footer block> not allow to remove
        handled = true;
      } else {
        //selection range contains footer block
        if (selectionState.getEndOffset() !== selectionState.getStartOffset()) {
          if (currentAnchorKey !== selectionState.getFocusKey()) {
            //multiple block selected
            var startKey = selectionState.getStartKey(),
                endKey = selectionState.getEndKey();

            while (startKey !== endKey) {
              if (this._isFooterContains(contentState.getBlockForKey(startKey))) {
                handled = true;
                break;
              } else {
                var blockAfter = contentState.getBlockAfter(startKey);

                if (blockAfter) {
                  startKey = blockAfter.getKey();
                } else {
                  break;
                }
              }
            }
          }
        } else {
          //check cursor position
          var removeSiblingBlock = command === "delete" ? selectionState.getFocusOffset() === selectionState.getEndOffset() : selectionState.getFocusOffset() === 0;

          if (removeSiblingBlock) {
            var blockToDelete = command === "delete" ? contentState.getBlockAfter(currentAnchorKey) : contentState.getBlockBefore(currentAnchorKey);

            if (blockToDelete && this._isFooterContains(blockToDelete)) {
              //check footer entity
              handled = true;
            }
          }
        }
      }
    }

    if (!handled) {
      var newState = _draftJs.RichUtils.handleKeyCommand(editorState, command);

      if (newState) {
        handled = true;
        this.onChange(newState);
      }
    }

    return handled ? 'handled' : 'not-handled';
  };

  _proto._onTab = function _onTab(e) {
    var maxDepth = 4;
    this.onChange(_draftJs.RichUtils.onTab(e, this.context.editorState, maxDepth));
  };

  _proto._handleReturn = function _handleReturn(event) {
    var _this3 = this;

    if (!event.shiftKey) {
      setTimeout(function () {
        var editorState = _this3.context.editorState;
        var selection = editorState.getSelection();
        var contentState = editorState.getCurrentContent();
        var currentBlock = contentState.getBlockForKey(selection.getEndKey());
        var endOffset = selection.getEndOffset();
        var atEndOfBlock = endOffset === currentBlock.getLength();
        var resetStyleNewLine = true;

        var noReset = _this3.blocksWithoutStyleReset.includes(currentBlock.type);

        if (atEndOfBlock && resetStyleNewLine) {
          var blockType = noReset ? currentBlock.type : "unstyled";

          var newEditorState = _draftJs.RichUtils.toggleBlockType(editorState, blockType);

          _this3.onChange(newEditorState);
        }
      });
      return false;
    }

    var editorState = this.context.editorState;
    var currentContent = editorState.getCurrentContent();
    var currentSelection = editorState.getSelection();
    var contentBlock = currentContent.getBlockMap().get(currentSelection.getFocusKey());
    var contentText = contentBlock.getText();

    if (contentText.charAt(currentSelection.focusOffset - 1) === "\n" || contentText.charAt(currentSelection.focusOffset) === "\n") {
      return false;
    }

    var newState = _draftJs.RichUtils.insertSoftNewline(editorState);

    this.onChange(newState);
    return true;
  };

  _proto._onMentionSearchChange = function _onMentionSearchChange(_ref) {
    var value = _ref.value;
    this.setState({
      mentions: (0, _SuggestionsFilter["default"])(value, this.props.customAttributes)
    });
  };

  _proto.render = function render() {
    var _this4 = this;

    var _this$context = this.context,
        editorState = _this$context.editorState,
        selectedTheme = _this$context.selectedTheme;

    if (!editorState) {
      return /*#__PURE__*/_react["default"].createElement("div", null, "LOADING....");
    } // If the user changes block type before entering any text, we can
    // either style the placeholder or hide it. Let's just hide it now.


    var className = 'RichEditor-editor';
    var contentState = editorState.getCurrentContent();

    if (!contentState.hasText()) {
      if (contentState.getBlockMap().first().getType() !== 'unstyled') {
        className += ' RichEditor-hidePlaceholder';
      }
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "p-4 custom-bg"
    }, /*#__PURE__*/_react["default"].createElement(_SettingsTools["default"], {
      settingsComponents: [this.customAttributeSetting.AddAttribute],
      intervalDelay: 1000
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "d-flex",
      ref: this.editorRef
    }, /*#__PURE__*/_react["default"].createElement(_SideToolbar["default"], {
      editorRef: this.editorRef,
      plugins: {
        emoji: emojiPlugin,
        image: this.imagePlugin
      },
      container: this,
      settingsComponents: [this.customAttributeSetting.AddAttribute],
      uploadImage: this.props.uploadImage,
      enableTools: ["emoji", _Constants["default"].ENTITY_TYPES.IMAGE, _Constants["default"].ENTITY_TYPES.BUTTON]
    }), /*#__PURE__*/_react["default"].createElement(_shoutoutThemesEnterprise.Card, {
      className: "flex-grow-1 editor-input-box"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "RichEditor-root",
      onClick: this.focus
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: className
    }, /*#__PURE__*/_react["default"].createElement(_draftJsPluginsEditor["default"], {
      editorState: editorState,
      handleKeyCommand: this.handleKeyCommand,
      onChange: this.onChange,
      onTab: this.onTab,
      placeholder: "Start creating your template...",
      ref: function ref(element) {
        _this4.editor = element;
      },
      spellCheck: true,
      plugins: this.plugins,
      blockStyleFn: blockStyleFn,
      customStyleFn: this.customStyleFn,
      customStyleMap: selectedTheme,
      handleReturn: this._handleReturn,
      blockRenderMap: this.blockRenderMap
    }), /*#__PURE__*/_react["default"].createElement(this.InlineToolbar, null), /*#__PURE__*/_react["default"].createElement(BlockInlineToolbarTool, null), /*#__PURE__*/_react["default"].createElement(this.MentionSuggestions, {
      onSearchChange: this._onMentionSearchChange,
      suggestions: this.state.mentions,
      entryComponent: _EntryComponent["default"]
    }), /*#__PURE__*/_react["default"].createElement("br", null))))));
  };

  return DraftEmailEditor;
}(_react["default"].Component);

exports["default"] = DraftEmailEditor;

_defineProperty(DraftEmailEditor, "contextType", _EditorContext.EditorContext);